import { Button, Icon } from "@mui/material";
import { themeBBJ } from "@style/theme/material.theme";
import { useRef, useState } from "react";
import { DropdownPopover } from "./DropdownPopover";

/**
 * Dropdown Button Component
 * @param {Object} props
 * @param {String} id Dropdown Button id
 * @param {Boolean} open
 * @param {String} buttonText Dropdown Button text
 * @param {Object} togglerProps Dropdown Button Component props
 * @param {Function} onClick Function to execute on input click
 * @param {Element} children Dropdown Popover children
 * @returns JSX.Element
 */
export const ButtonDropdown = ({
  id,
  open,
  buttonText,
  togglerProps,
  onClick,
  onClose,
  children,
  PaperProps,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    onClick();
  };

  const handleClose = () => {
    if (onClose && typeof onClose === "function") {
      onClose();
    } else {
      onClick();
    }
    setAnchorEl(null);
  };

  const buttonRef = useRef(null);

  return (
    <>
      {/* Button Part */}
      <Button
        id={`${id}-button`}
        aria-haspopup="true"
        onClick={handleClick}
        sx={
          props.variant !== "text"
            ? {
                textTransform: "none",
                border: `1px solid ${themeBBJ.palette.primary.main}`,
                paddingLeft: "18px",
                background: "white",
                color: themeBBJ.palette.primary.main,
                ...themeBBJ.typography.body1,
              }
            : {
                textTransform: "none",
                border: "1px solid transparent",
                fontSize: "16px",
                padding: "10px",
                fontFamily: themeBBJ.typography.button.fontFamily,
                fontWeight: themeBBJ.typography.button.fontWeight,
                color: themeBBJ.palette.primary.main,
              }
        }
        endIcon={!togglerProps.icon && <Icon sx={{ pr: 1 }}>{!open ? "arrow_drop_down" : "arrow_drop_up"}</Icon>}
        propsref={buttonRef}
        {...togglerProps}
      >
        {togglerProps.icon && togglerProps.icon}
        {buttonText}
      </Button>

      {/* Dropdown Part */}
      <DropdownPopover
        id={`${id}-popover`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          ...PaperProps,
          sx: {
            ...PaperProps.sx,
            minWidth: buttonRef?.current?.offsetWidth || 150,
          },
        }}
        {...props}
      >
        {children}
      </DropdownPopover>
    </>
  );
};
